import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Whether the routed vacancy page shows a Direct request. The URL alone can't
 * tell (/market/vacancies/:id serves both kinds), so the detail page reports it
 * and the sidebar highlights Intake instead of Overview.
 */
@Injectable({ providedIn: 'root' })
export class MarketNavService {
  readonly directRequestOpen = new BehaviorSubject<boolean>(false);
}
